module.exports = __webpack_public_path__ + "img/3_4.2db15781.png";